import { Injectable } from '@angular/core';
import { Store } from '@examdojo/state';
import { createStore, withProps } from '@ngneat/elf';
import { PayoutAccountStoreModel } from './payout-account.model';

export interface PayoutAccountState {
  payoutAccount: PayoutAccountStoreModel | null;
  loading: boolean;
  error: unknown;
}

@Injectable({
  providedIn: 'root',
})
export class PayoutAccountStore extends Store<PayoutAccountState> {
  constructor() {
    super(
      createStore(
        { name: 'payout-account' },
        withProps<PayoutAccountState>({
          payoutAccount: null,
          loading: false,
          error: null,
        }),
      ),
    );
  }

  setPayoutAccount(account: PayoutAccountStoreModel | null): void {
    this.updateStore((state) => ({
      ...state,
      payoutAccount: account,
      loading: false,
      error: null,
    }));
  }

  setLoading(loading: boolean): void {
    this.updateStore((state) => ({ ...state, loading }));
  }

  resetToInitialState(): void {
    this.updateStore(() => ({
      payoutAccount: null,
      loading: false,
      error: null,
    }));
  }

  getEntity(): PayoutAccountStoreModel | null {
    return this.getValue().payoutAccount;
  }
}
